/**
 * Created by slava on 24.03.17.
 */

const HelpByFiveAttemptsWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        const styles = cleverapps.styles.HelpByFiveAttemptsWindow;

        const animation = this.createAnimation();

        const text = this.createText();
        
        const content = new cleverapps.Layout([animation, text], {
            margin: styles.margin,
            direction: cleverapps.UI.VERTICAL
        });

        this._super({
            title: Messages.get("HelpByFiveAttempts.title"),
            name: "helpbyfiveattemptswindow",
            content,
            button: {
                text: Messages.get("OK"),
                onPressed: this.close.bind(this)
            },
            openSound: bundles.help_by5_attempts_window.urls.perfect_effect
        });
    },

    createAnimation: function () {
        const styles = cleverapps.styles.HelpByFiveAttemptsWindow;

        const node = new cc.Node();
        node.setAnchorPoint(0.5, 0.5);
        node.setContentSize2(styles.animation);

        const animation = new cleverapps.Spine(bundles.help_by5_attempts_window.jsons.help_from_buddies_json);
        node.addChild(animation);
        animation.setAlignment(styles.animation);
        animation.setAnimation(0, "animation", true);

        return node;
    },

    createText: function () {
        const styles = cleverapps.styles.HelpByFiveAttemptsWindow;

        const text = cleverapps.UI.generateOnlyText(Messages.get("HelpByFiveAttempts.text"), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setDimensions(styles.text.width, 0);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        return text;
    },

    onClose: function () {
        if (Game.currentGame) {
            Game.currentGame.helpByFiveAttempts();
        }
    }
});

HelpByFiveAttemptsWindow.showIfCan = function () {
    if (!Game.currentGame.canHelpByFiveAttempts()) {
        return;
    }

    const amountAttempts = match3.levelAttempts.getAttempts();
    if (amountAttempts < 5 || amountAttempts % 5 !== 0) {
        return;
    }

    cleverapps.metrics.logEvent(cleverapps.EVENTS.HELP_BY_FIVE_ATTEMPTS);

    cleverapps.focusManager.display({
        focus: "HelpByFiveAttemptsWindow",
        action: function (f) {
            new HelpByFiveAttemptsWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

HelpByFiveAttemptsWindow.prototype.listBundles = function () {
    return ["help_by5_attempts_window"];
};

cleverapps.styles.HelpByFiveAttemptsWindow = {
    margin: 20,

    animation: {
        width: 450,
        height: 400,

        x: { align: "center" },
        y: { align: "center", dy: -100 }
    },

    text: {
        width: 600
    }
};